import React from 'react';

const ReportsIcon = () => {
    return (
        <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M16.34 22H2V2h16v7.34l2 2V0H0v24h18.34l-2-2z"/><path d="M15.61 18.7l4.63 4.63 1.42-1.42L17 17.28a5.47 5.47 0 1 0-1.41 1.42zm-5.61-7a3.5 3.5 0 1 1 0 4.95 3.48 3.48 0 0 1 0-4.95zM4 5h12v2H4zM4 17h2v2H4zM4 9h2v2H4zM4 13h2v2H4z"/></svg>
    )
};

export default ReportsIcon;